export default __webpack_public_path__ + "assets/images/platforms/8220288fec439e2500d445a67f11d079.png";